import { render, staticRenderFns } from "./CompanyEditCard.vue?vue&type=template&id=1978a424"
import script from "./CompanyEditCard.vue?vue&type=script&lang=js"
export * from "./CompanyEditCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports